module.exports = __webpack_public_path__ + "img/ico_medico-hospital.061ef369.svg";